module.exports = __webpack_public_path__ + "img/2019プール掃除 2.92b76f72.jpg";